var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsInt, Min } from 'class-validator';
/**
 * Body of `POST /challenge/clock/advance` — the absolute target offset (ms)
 * to advance the participant's virtual clock to. Forward-only: the server
 * rejects a target below the current offset (PRD #918, slice 1 / #919).
 *
 * The client computes `target = currentOffset + delta` from the offset it
 * polls on `/challenge/session/:id/progress`; the server is the source of
 * truth and the value here is validated, not trusted.
 */
export class AdvanceChallengeClockDto {
    targetOffsetMs;
}
__decorate([
    IsInt(),
    Min(0),
    __metadata("design:type", Number)
], AdvanceChallengeClockDto.prototype, "targetOffsetMs", void 0);
//# sourceMappingURL=advance-challenge-clock.dto.js.map